import React from 'react';
import { useTranslation } from 'next-i18next';

import {
  Delivery,
  PriceTag,
  Stores,
  Calendar,
  Fast,
  Support,
} from '@common/components/Icons';

import { Title, Section } from './PaymentBenefitBlock.styled';
import {
  BenefitsWrapper,
  Benefit,
  BenefitIconWrapper,
} from './Benefits.styled';

const Benefits = () => {
  const { t } = useTranslation();

  return (
    <Section>
      <Title>{t('shop.benefitBlock.benefitHeadline', 'Deine Vorteile')}</Title>
      <BenefitsWrapper>
        <Benefit>
          <BenefitIconWrapper>
            <PriceTag />
          </BenefitIconWrapper>
          {t('shop.benefitBlock.benefitDiscount', 'Bis 70% Rabatt auf alles')}
        </Benefit>
        <Benefit>
          <BenefitIconWrapper>
            <Fast />
          </BenefitIconWrapper>
          {t('shop.benefitBlock.benefitDelivery', 'Schnelle Lieferung')}
        </Benefit>
        <Benefit>
          <BenefitIconWrapper>
            <Stores />
          </BenefitIconWrapper>
          {t(
            'shop.benefitBlock.benefitFreeReturn',
            'Kostenlose Rückgabe in den Filialen',
          )}
        </Benefit>
        <Benefit>
          <BenefitIconWrapper>
            <Calendar />
          </BenefitIconWrapper>
          {t('shop.benefitBlock.benefitRefund', '10 Tage Rückgaberecht')}
        </Benefit>
        <Benefit>
          <BenefitIconWrapper>
            <Delivery />
          </BenefitIconWrapper>
          {t(
            'shop.benefitBlock.benefitShipping',
            'Günstiger Versand und Rückversand',
          )}
        </Benefit>
        <Benefit>
          <BenefitIconWrapper>
            <Support />
          </BenefitIconWrapper>
          {t('shop.benefitBlock.benefitSupport', 'Gratis Support')}
        </Benefit>
      </BenefitsWrapper>
    </Section>
  );
};

export default Benefits;
